const state = {
  cardInfo: {
    cardNo: '',
    compName: '',
    compType: '',
    priCard: 1,
    status: 1,
    balance: '',
    integral: ''
  },
  viceCardList: []
}

const mutations = {
  RESET_CARD_INFO(state, cardNo) {
    const { cardInfo } = state

    cardInfo.cardNo = cardNo
    cardInfo.compName = ''
    cardInfo.compType = ''
    cardInfo.priCard = 1
    cardInfo.status = 1
    cardInfo.balance = ''
    cardInfo.integral = ''
  },
  SET_CARD_INFO(state, { cardNo, compName, compType, priCard, status, balance, integral }) {
    const { cardInfo } = state

    cardInfo.cardNo = cardNo
    cardInfo.compName = compName
    cardInfo.compType = compType
    cardInfo.priCard = priCard
    cardInfo.status = status
    cardInfo.balance = balance
    cardInfo.integral = integral
  },
  SET_VICE_CARD_LIST(state, list) {
    state.viceCardList = list
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
